import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: calc(100% - 120px);
  padding-top: 16px;
`;
